import { render, staticRenderFns } from "./TeacherInteractionInfo.vue?vue&type=template&id=f48c2b3e"
import script from "./TeacherInteractionInfo.vue?vue&type=script&lang=js"
export * from "./TeacherInteractionInfo.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./TeacherInteractionInfo.vue?vue&type=style&index=1&id=f48c2b3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports